

















































import gql from 'graphql-tag';
import * as R from 'ramda';
import Vue from 'vue';

import { Retailer } from '@/core/entity';

interface Option {
  value: string;
  label: string;
  isLeaf: boolean;
  children?: Option[];
}

interface Outlet {
  id: string;
  name: string;
}

const getRetailerQl = gql`
  query($country: String!) {
    retailers: listRetailer(country: $country) {
      id
      name
    }
  }
`;

const getOutletQl = gql`
  query($id: ID!) {
    retailer: retailer(id: $id) {
      id
      outlets {
        id
        name
      }
    }
  }
`;

export default Vue.extend({
  props: {
    country: {
      type: String as () => 'my' | 'sg' | 'id',
      required: true,
    },
    value: {
      type: Array as () => string[],
    },
  },

  async mounted() {
    const result = await this.$apollo.query({
      query: getRetailerQl,
      fetchPolicy: 'cache-first',
      variables: {
        country: this.country,
      },
    });

    this.options = R.map(
      (r) => ({
        value: r.id,
        label: r.name,
        isLeaf: false,
      }),
      result.data.retailers,
    );

    this.loading = false;
  },

  data() {
    const value: string[] = this.value || [];

    return {
      loading: true,
      options: [] as Option[],
      outlets: value,
      selected: [] as string[],
    };
  },

  computed: {
    tags(): Outlet[] {
      return R.pipe(
        R.map<Option, Option[]>((o) => o.children || []),
        // @ts-ignore Typescript issue with R.flatten
        R.flatten,
        R.map((o: Option) => ({ id: o.value, name: o.label })),
        R.filter((o: Outlet) => R.contains(o.id, this.outlets)),
      )(this.options!);
    },
  },

  watch: {
    value(newVal: string[] = []) {
      this.outlets = newVal;
    },
  },

  methods: {
    async loadOutlets(selectedOptions: any) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;

      const retailerId = targetOption.value;

      const result = await this.$apollo.query({
        query: getOutletQl,
        variables: { id: retailerId },
        fetchPolicy: 'cache-first',
      });

      // update selected options with children
      const idx = R.findIndex(R.propEq('value', retailerId), this.options);
      const lens = R.lensPath([idx]);
      this.options = R.over(
        lens,
        (c) => {
          return {
            ...targetOption,
            loading: false,
            children: R.map(
              (o) => ({
                label: o.name,
                value: o.id,
              }),
              result.data.retailer.outlets,
            ),
          };
        },
        this.options,
      );
    },

    onAdd(e: Event) {
      e.preventDefault();

      if (this.selected.length === 2) {
        // val[0] = Retailer; val[1] = Outlet
        const [retailerId, outletId] = this.selected;
        const retailer = R.find(R.propEq('value', retailerId), this.options);
        const outlet = R.find(R.propEq('value', outletId), retailer!.children!);

        const val = {
          id: outlet!.value,
          name: `${retailer!.label} / ${outlet!.label}`,
        };

        if (!R.find(R.propEq(0, val.id))(this.outlets)) {
          const outlets = R.append(val.id, this.outlets);

          this.triggerChange(outlets);
        }

        this.selected = [];
      }
    },

    onRemove(outletId: string) {
      const outlets = R.reject((id) => id === outletId, this.outlets);
      this.triggerChange(outlets);
    },

    triggerChange(val: string[]) {
      this.$emit('change', R.clone(val));
    },
  },
});
